import { render, staticRenderFns } from "./CompassIndustryNew.vue?vue&type=template&id=3356e16c&scoped=true&"
import script from "./CompassIndustryNew.vue?vue&type=script&lang=ts&"
export * from "./CompassIndustryNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356e16c",
  null
  
)

export default component.exports